import $ from "jquery";

/* Open the first section on load */
$(".accordition__question").on('focus', function () {
  if (!$(this).data("mouseDown"))
    $(this).click();
});

$(".accordition__question").on('mousedown', function () {
  $(this).data("mouseDown", true);
});

$(".accordition__question").on('mouseup', function () {
  $(this).removeData("mouseDown");
});

$(".accordition__question").on('click', function (e) {
  var $item = $(this).closest('.accordition__item');
  if ($(this).hasClass('is-active')) {
    $('.accordition__question').removeClass('is-active');
    $('.accordition__item').removeClass('is-active');
    $('.accordition__answer').removeClass('is-active').slideUp();
  } else {
    $('.accordition__question').removeClass('is-active');
    $('.accordition__item').removeClass('is-active');
    $('.accordition__answer').removeClass('is-active').slideUp();
    $(this).addClass('is-active');
    $item.addClass('is-active');
    $(this).next('.accordition__answer').addClass('is-active').slideDown();
  }
});
